export default __webpack_public_path__ + "static/media/apartment-outside.5bd3ee5c.jpg";